export function useNavigationPropagation() {
  const dispatchEventNavigationChanged = () => {
    window.dispatchEvent(new CustomEvent('anzu.gallery.navigated', {}))
  }

  const dispatchEventNavigationSource = (sourceName: string) => {
    window.dispatchEvent(
      new CustomEvent('anzu.gallery.navigated-source', {
        detail: {
          source: sourceName,
        },
      })
    )
  }

  return {
    dispatchEventNavigationChanged,
    dispatchEventNavigationSource,
  }
}
